// @flow
export const SEGMENTATION_TOGGLE_DROPDOWN_VISIBILITY =
    'SEGMENTATION/TOGGLE_DROPDOWN_VISIBILITY';

type ToggleDropdownVisibilityAction = {
    type: 'SEGMENTATION/TOGGLE_DROPDOWN_VISIBILITY',
    payload: boolean
};

export type Action = ToggleDropdownVisibilityAction;

const ACTION_CREATORS = {
    toggleDropdownVisibility(
        isVisible: boolean
    ): ToggleDropdownVisibilityAction {
        return {
            type: SEGMENTATION_TOGGLE_DROPDOWN_VISIBILITY,
            payload: isVisible
        };
    }
};

export default {...ACTION_CREATORS};
